import { WorkUnitInvocationLog } from "./WorkUnitInvocationLog";

export type DurableFunctionAppName = "mailroom" | "workloads";

export type DurableFunctionInstanceStatus = "Completed" | "Running" | "Failed" | "Terminated" | "Pending";

export type DurableFunctionInstanceType = "BulkWorkload" | "Playlist" | "Workload";

export interface CustomStatus {
    message: string;
}

export interface CustomStatusWithIds extends CustomStatus{
    workloadInstanceIds: string[];
}

export interface PlaylistCustomStatus extends CustomStatusWithIds {
    failedAndAwaitingRestart: boolean;
}

export interface DurableFunctionInstance {
    Name: string;
    durableFunctionInstanceId: string;

    createdAt: string
    Timestamp: string;
    LastUpdatedTime: string;

    runtimeStatus: DurableFunctionInstanceStatus;
    input: any;
    Output: string | undefined; // JSON or http
    customStatus: any;
}

export interface GroundFloorDurableFunctionInstance extends DurableFunctionInstance {
    tenantName: string;
    tenantId: string;
    schoolCode: string;

    // workloads
    workloadName?: string;
    workUnitInvocations: WorkUnitInvocationLog[];

    // playlists
    playlistName?: string;
    failedAndAwaitingRestart: boolean | null;

    bulkWorkloadName?: string;
    
    createdByUserId: string | null;
    createdByUserPrincipalName: string | null;

    customStatus: CustomStatus | null;
    customStatusMessage: string | null;
}


export class DurableFunctionInstanceHelpers {
    public static ParseOutput(instance: DurableFunctionInstance): any | undefined {
        if (instance.Output == undefined ||
            instance.Output == "" ||
            instance.Output.startsWith("http")) {
            return undefined;
        }

        try {
            return JSON.parse(instance.Output);
        }
        catch (ex) {
            return instance.Output;
        }
    }

    public static GetDurableFunctionInstanceType(instance: GroundFloorDurableFunctionInstance): DurableFunctionInstanceType {
        if (instance.bulkWorkloadName) {
            return "BulkWorkload";
        }
        else if (instance.playlistName) {
            return "Playlist";
        }
        else {
            return "Workload";
        }
    }

    public static GetDurableFunctionInstanceName(instance: GroundFloorDurableFunctionInstance): string {

        let instanceType = this.GetDurableFunctionInstanceType(instance);

        if (instanceType == "Playlist") {
            return `[Playlist] ${instance.playlistName}`;
        }
        else if (instanceType == "BulkWorkload") {
            return `[Bulk] ${instance.bulkWorkloadName}`;
        }
        else {
            return instance.workloadName!;
        }
    }
}